export default {
  ru: {
    label: 'Номер телефона',
    placeholder: 'Введите ваш номер телефона',
    error: 'Телефон введен неверно',
  },
  en: {
    // en
  },
};
